import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class OutcomeProps {
  @Inlet(Accepts.Image) public image?: Types["Image"];
  @Inlet(Accepts.MarkdownText) public text?: Types["MarkdownText"];
  @Inlet(Accepts.String) public downloadButtonLabel?: Types["String"];
  @Inlet(Accepts.Boolean) public quitStory?: Types["Boolean"];
}

export const OutcomeDefinition = defineElement("outcome", OutcomeProps, {
  versionRequired: "0.80.0",
});
